import { render } from "./TeamDetailsArea.vue?vue&type=template&id=0eacea10"
import script from "./TeamDetailsArea.vue?vue&type=script&lang=js"
export * from "./TeamDetailsArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__